import React,{useState} from "react";
import { Card, Badge } from "react-bootstrap";
import { Linkedin, Phone, Mail, Eye, MapPin, Briefcase, Globe2, Star,CalendarDays,Timer,FileCheck,Home,DollarSign, Globe, Currency, CurrencyIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const CandidateCard = ({ candidate, onViewDetails,highlightTerms = [] }) => {
  const {
 fullName,
    currentJobTitle,
    currentCompany,
    locations,
    yearsOfExperience,
    authorizedToWorkInUS,
    needsSponsorshipToWorkInUS,
    authorizedToWorkInCanada,
    needsSponsorshipToWorkInCanada,
    usCitizen,
    education,
    workPermitDocuments,
    desiredJobTitles,
    desiredWorkSettings,
    workPreferences,
    dateLastUpdated,
    dateLastActive,
    likelyToMove,
    skills,
    email,
    phone,
    socialProfiles,
    country,
    region,
    preferredJobTitles,
     

  } = candidate;

  const location = locations?.[0]?.text || `${region || ""}, ${country || ""}`;
    const linkedInProfile = socialProfiles?.find((p) => p.source === "linkedin");
  const diceProfile = socialProfiles?.find((p) => p.source === "Dice");
  const willingToRelocate = workPreferences?.[0]?.willingToRelocate;
  const visaRequired = workPreferences?.[0]?.visaRequired ? "Yes" : "No";

  const navigate = useNavigate();
  const workAuth = usCitizen
    ? "US Citizen"
    : authorizedToWorkInUS
    ? "Authorized to work in US"
    : needsSponsorshipToWorkInUS
    ? "Needs Sponsorship (US)"
    : "Work auth unknown";

  const canadaAuth = authorizedToWorkInCanada
    ? "Authorized to work in Canada"
    : needsSponsorshipToWorkInCanada
    ? "Needs Sponsorship (Canada)"
    : null;

  const salary = workPreferences?.[0]?.annualSalary;
  const hourly = workPreferences?.[0]?.hourlyRate;

   const [showAll, setShowAll] = useState(false);
 const visibleSkills = showAll ? skills : skills.slice(0, 15);
const highlightText = (text, terms = []) => {
  if (!text) return "";
  if (!terms || terms.length === 0) return text;

  // Normalize and clean terms: split comma-separated entries, remove blanks
  const safeTerms = terms
    .flatMap(t => t.split(/[,\s]+/)) // split on commas or spaces
    .filter(t => t && t.trim().length > 0)
    .map(t => t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")); // escape regex chars

  if (safeTerms.length === 0) return text;

  const regex = new RegExp(`\\b(${safeTerms.join("|")})\\b`, "gi");
  return text.replace(regex, `<mark style="background-color: #ffff00;">$1</mark>`);
};



  return (
    <>
      <style>{`
        .candidate-name {
          font-size: 1.2rem;
          font-weight: 600;
          color: #0073b1;
        }
        .candidate-meta {
          font-size: 0.9rem;
          color: #555;
        }
        .skill-badge {
          background-color: #f0f0f0;
          border: 1px solid #ddd;
          font-size: 13px;
          border-radius: 5px;
          margin: 2px;
          padding: 6px 10px;
        }
        .icon-link {
          margin-left: 10px;
          color: #0073b1;
        }
        .icon-link:hover {
          color: #005f91;
        }
        .candidate-actions {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-top: 10px;
          flex-wrap: wrap;
        }
        .btn-more-details {
          background-color: transparent;
          color: #0d6efd;
          border: 1px solid #0d6efd;
          font-size: 0.85rem;
          padding: 4px 10px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          gap: 6px;
          transition: all 0.2s ease;
        }
        .btn-more-details:hover {
          background-color: #0d6efd;
          color: #fff;
        }
        .info-line {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 0.9rem;
          color: #555;
        }

        /* ✅ New styles for preferred roles */
        .preferred-roles {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
          margin-top: 6px;
          margin-bottom: 8px;
        }

        .preferred-role-tag {
          background-color: #fff3b0;
          border: 1px solid #f1e08c;
          color: #444;
          font-size: 11px;
          font-weight: 500;
          border-radius: 6px;
          padding: 3px 8px;
        }

        .preferred-role-icon {
          color: #f4b400;
          margin-right: 4px;
        }
           
      .w-90 b {
        color: #52514e;
        font-weight: 600;
          }
      `}</style>

      <Card className="shadow-sm mb-3 p-3 rounded-3 border-0" style={{ background: "#fff" }}>
        <div className="d-flex justify-content-between align-items-start">
          {/* 🔹 Left Section */}
          <div className="w-90">
            {/* Candidate Name */}
<div
  className="candidate-name mb-1"
  dangerouslySetInnerHTML={{
    __html: highlightText(fullName,  highlightTerms),
  }}
></div>

            {/* Current Job */}
            <div className="candidate-meta mb-1">
              <Badge bg="success" className="ms-2 mr-2">
                {currentJobTitle}
              </Badge>
                 {currentCompany && (
    <span
      className="text-muted"
      dangerouslySetInnerHTML={{
        __html: `@ ${highlightText(currentCompany, highlightTerms)}`,
      }}
    />
  )}
            </div>
{/* Prefferred Job */}
  {desiredJobTitles?.length > 0 && (
  <div className="info-line mt-1">
    <Star size={14} color="#00a7ac" className="me-1" />
    <span
  className="text-muted me-2"
  dangerouslySetInnerHTML={{
    __html: `<b>Preferred</b>: ${highlightText(desiredJobTitles.join("  ||  "), highlightTerms)}`,
  }}
></span>

</div>
)}
<div className="info-line mt-1">   
 {/* Location,Likely to Switch,Work permit */}
    <MapPin size={14} color="#00a7ac" />
  <span className="me-2"><b>Location</b> : {location}</span>
   <span className="mx-2 text-muted">||</span>
     <Briefcase size={14} color="#00a7ac" className="me-1" />
    <span>
     <b> Likely to Switch </b>: {likelyToMove ? "Yes" : "No"}
    </span>
    <span className="mx-2 text-muted">||</span>
    {workPermitDocuments && workPermitDocuments.length > 0 && (
  <>
    <Globe size={14} color="#00a7ac" />
    <span><b>Permit</b> : {workPermitDocuments?.join(", ")}</span>
  </>
)}
    </div>
            {/*  Experience , Willing to relocate,  💰 Salary */}
         <div className="info-line mt-1">       
   <CalendarDays size={14} color="#00a7ac" />
   <span className="me-2"><b>Experience</b> : {yearsOfExperience} yrs exp</span>
  <span className="mx-2 text-muted">||</span>  
  <Globe2 size={14} color="#00a7ac" />
  <span className="text-muted me-2"><b>Willing to relocate</b> : {willingToRelocate ? "Yes" : "No"}</span> 

  <span className="mx-2 text-muted">||</span>
 
  {workPreferences?.[0]?.annualSalary?.min ? (
    <>
      <CurrencyIcon size={14} color="#00a7ac" className="me-1" />
      <span className="text-muted me-2"><b>Salary</b> :
        {workPreferences[0].annualSalary.currency}{" "}
        {workPreferences[0].annualSalary.min.toLocaleString()}
      </span>
    </>
  ) : (
    <>
      <CurrencyIcon size={14} color="#00a7ac" className="me-1" />
      <span className="text-muted">No desired salary disclosed</span>
    </>
  )}
</div>

 {/* 🌎 Employement type, 🕒 Updated +  ⏰Last Active */}
         <div className="info-line mt-1 d-flex align-items-center flex-wrap"
  style={{ gap: "6px" }} // optional spacing
>  
  {workPreferences?.length > 0 &&
    workPreferences[0]?.employmentType?.length > 0 && (
      <>
        <Home size={14} color="#00a7ac" className="me-1" />
        <span><b>EmploymentType</b> : {workPreferences[0].employmentType.join(", ")}</span>
        <span className="text-muted">||</span>
      </>
    )}
  <Timer size={14} color="#00a7ac" className="me-1" />
  <span className="text-muted">
    <b>Updated</b> : {new Date(dateLastUpdated).toLocaleDateString()}
  </span>
  <span className="text-muted">||</span>
   <Timer size={14} color="#00a7ac" className="me-1" />
  <span className="text-muted">
    <b>Last Active</b> : {new Date(dateLastActive).toLocaleDateString()}
  </span>
</div>     
 {/* 🧠 Skills */}
            <div className="d-flex flex-wrap mt-2">
             {visibleSkills.map((s, i) => (
  <div
    className="skill-badge"
  key={i}
  dangerouslySetInnerHTML={{
    __html: `${highlightText(s.skill, highlightTerms)} ${s.yearsUsed ? `(${s.yearsUsed} yrs)` : ""}`,

    }}
  />
))}


      {skills.length > 15 && (
        <div
          className="text-primary small ms-2 mt-2"
          style={{ cursor: "pointer" }}
          onClick={() => setShowAll(!showAll)}
        >
          {showAll ? "Show less" : `+${skills.length - 15} more`}
        </div>
      )}
            </div>

            {/* 🔹 Action Buttons */}
            <div className="candidate-actions">
              <button
                className="btn btn-primary btn-more-details"
                title="Click to view details • Ctrl+Click to open in new tab"
                onClick={async (e) => {
                  e.stopPropagation();
                  const candidateId = candidate.candidateId || candidate.id;
                  const url = `/Employer/candidate-details/${candidateId}`;

                  if (e.ctrlKey || e.metaKey) {
                    const result = await Swal.fire({
                      title: "View Candidate Details?",
                      text: "Viewing this candidate counts as one view. Proceed?",
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonText: "Yes, open in new tab",
                      cancelButtonText: "Cancel",
                    });

                    if (result.isConfirmed) window.open(url, "_blank");
                  } else {
                    onViewDetails(candidate);
                  }
                }}
              >
                More Details →
              </button>
            </div>
          </div>

          {/* 🔹 Right Section (Icons) */}
          <div className="text-end w-10">
            <div className="d-flex justify-content-end align-items-center gap-2">
              {linkedInProfile && (
                <a
                  href={linkedInProfile.url}
                  target="_blank"
                  rel="noreferrer"
                  className="icon-link"
                  title="LinkedIn Profile"
                >
                  <Linkedin size={20} />
                </a>
              )}
              {diceProfile && (
                <a
                  href={diceProfile.url}
                  target="_blank"
                  rel="noreferrer"
                  className="icon-link"
                  title="Dice Profile"
                >
                  <img
                    src="https://dmf1ol3sc7oaa.cloudfront.net/64/dice.png"
                    alt="Dice"
                    width={20}
                  />
                </a>
              )}
              {phone && (
                <a href={`tel:${phone[0]}`} className="icon-link" title={`Call ${phone[0]}`}>
                  <Phone size={20} />
                </a>
              )}
              {email && (
                <a href={`mailto:${email[0]}`} className="icon-link" title={`Email ${email[0]}`}>
                  <Mail size={20} />
                </a>
              )}
              {/* <Eye size={20} className="icon-link" title="View Profile" /> */}
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};

export default CandidateCard;
